import axios from "axios";
import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useUser } from "../UserContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const UploadReplays = ({ laps }: { laps: number }) => {
  const { t } = useTranslation();
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [show, setShow] = useState(true);

  const handleButtonClick = () => {
    fileInputRef.current?.click(); // dispara el input hidden
  };

  const handleFilesSelected = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (!files || token == null) return;

    const selectedFiles = Array.from(files);
    const rplFiles = selectedFiles.filter(
      (file) =>
        file.name.toLowerCase().endsWith(".rpl") ||
        file.name.toLowerCase().endsWith(".ini")
    );
    if (rplFiles.length !== laps * 2) {
      toast.error(
        t("Please select exactly .rpl files", { laps: laps }) as string
      );
      return;
    }

    const tooBig = rplFiles.some((file) => file.size > 15 * 1024 * 1024);
    if (tooBig) {
      toast.error(t("Each file must be less than 15MB") as string);
      return;
    }

    const formData = new FormData();
    rplFiles.forEach((file) => {
      formData.append("replays", file);
    });

    formData.append("user", user);
    formData.append("token", JSON.parse(token).token);
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/uploadReplay`,
        formData
      )
      .then(({ data }) => {
        toast.success(t("Replays uploaded succesfully") as string);
        setShow(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        throw new Error(response);
      });
  };

  if (!show) return <></>;
  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".rpl,.ini"
        multiple
        style={{ display: "none" }}
        onChange={handleFilesSelected}
      />
      <Button variant="primary" onClick={handleButtonClick} className="upl-rep">
        {t("Upload Replays")}
      </Button>
    </>
  );
};

export default UploadReplays;
